/**
 * @generated SignedSource<<a2fdab68eacb488b1e6738bdafd66b83>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type datePickerField_updateWorkItemAllFieldTypesActionRenderer$data = {
  readonly fieldId: string;
  readonly name: string;
  readonly " $fragmentType": "datePickerField_updateWorkItemAllFieldTypesActionRenderer";
};
export type datePickerField_updateWorkItemAllFieldTypesActionRenderer$key = {
  readonly " $data"?: datePickerField_updateWorkItemAllFieldTypesActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"datePickerField_updateWorkItemAllFieldTypesActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "datePickerField_updateWorkItemAllFieldTypesActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "JiraDatePickerField"
};

(node as any).hash = "0d380d0ab2a0f9cab300ceca61bf6d48";

export default node;
